// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__3KnSR","container":"style_container__1K3Z-","footerNav":"style_footerNav__1xtJi"};